module.exports = __webpack_public_path__ + "static/media/icon_group.360f1825.png";